<template>
  <div class="row">
    <div class="col-12">
      <card card-body-classes="table-full-width" no-footer-line>
        <div>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <h4 class="card-title text-purple">
              {{ $t("app.modules.roles.edit.title") }}
            </h4>
          </div>
          <div class="col-12">
            <ValidationObserver ref="formEdit" v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(editRole)">
                <h3>
                  <small>Traducciones</small>
                </h3>

                <template>
                  <div
                    v-for="traduccion in payload.traducciones"
                    :key="traduccion.idRolTraduccion"
                  >
                    <div class="row">
                      <div class="col-sm-6">
                        <ValidationProvider
                          name="minLength"
                          rules="required|min:5"
                          v-slot="{ passed, failed }"
                        >
                          <fg-input
                            type="text"
                            :placeholder="traduccion.idioma"
                            :error="
                              failed
                                ? 'La longitud mínima para el nombre es de 5 '
                                : null
                            "
                            :hasSuccess="passed"
                            name="minLength"
                            label="Nombre del rol"
                            v-model="traduccion.nombre"
                          >
                          </fg-input>
                        </ValidationProvider>
                      </div>
                      <div class="col-sm-6">
                        <ValidationProvider
                          name="minLength"
                          rules="required|min:5"
                          v-slot="{ passed, failed }"
                        >
                          <fg-input
                            type="text"
                            :placeholder="traduccion.idioma"
                            :error="
                              failed
                                ? 'La longitud mínima para el nombre es de 5 '
                                : null
                            "
                            :hasSuccess="passed"
                            name="minLength"
                            label="Descripcion"
                            v-model="traduccion.descripcion"
                          >
                          </fg-input>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                </template>
                <h3>
                  <small>Permisos</small>
                </h3>
                <!-- Tabla de permisos -->
                <div class="row table-full-width">
                  <div class="col-sm-12">
                    <el-table stripe :data="tableData">
                      
                      <el-table-column
                        prop="titulo"
                        label="Modulo"
                      ></el-table-column>
                      
                      <el-table-column
                        prop="nombreModulo"
                        label="Permisos"
                      >
                      <template slot-scope="scope" class="image-slot">
                        <n-checkbox v-model="permiso.status" v-for="permiso in scope.row.permisos" :label="permiso.permiso" :key="permiso.id_ClaimsModule">{{permiso.permiso}}</n-checkbox>
                      </template>
                      
                      </el-table-column>

                    </el-table>
                  </div>
                </div>
                <!---->
                <div class="col-sm-6 form-group has-label">
                  <div class="row">
                    <label style="margin-left: 15px">Rol habilitado</label>
                  </div>
                  <template>
                    <n-switch v-model="item.active">
                      <i class="now-ui-icons ui-1_check" slot="on"></i>
                      <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                    </n-switch>
                  </template>
                </div>
                <div
                  slot="footer"
                  style="margin-top: 10px; padding-top: 20px;border-top: outset;"
                  class="text-right"
                >
                  <router-link :to="{ name: 'Roles' }" class="col-2">
                    <n-button class="pull-left btn-secondary">{{ $t("app.buttons.cancel") }}</n-button>
                  </router-link>

                  <n-button native-type="submit" type="primary">{{ $t("app.buttons.save") }}</n-button>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      tableData: [],
      item: {},
      payload: {
        id: 0,
        claveIdioma: "",
        usuario: 0,
        traducciones: []
      },
      switches: {
        withIconsOn: true
      },
      minLength: "",
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false
      },
      modalEdit: false
    };
  },
  mounted() {

    /*
    EventBus.$on("perfiles-edit", async item => {
      console.log(item);
      this.tableData = [];
      this.item = item;
      this.payload.traducciones = [];
      (this.payload.id = item.id),
        (this.payload.claveIdioma = ""),
        (this.payload.usuario = 1),
        this.$swal.fire({
          title: this.$t("app.promps.wait"),
          html:
            '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
          showConfirmButton: false
        });
      await this.initPerfilesEdit();
      this.$swal.close();
      this.modalEdit = true;
    });*/

    this.tableData = [];
    this.$swal.fire({
          title: this.$t("app.promps.wait"),
          html:
            '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
          showConfirmButton: false
        });
    console.log(this.$route.params);
    this.item = this.$route.params
    console.log(this.item);
    this.initPerfilesEdit();
    this.$swal.close();
  },
  methods: {
    cancelEdit() {
      this.tableData = [];
      this.modalEdit = false;
      this.payload.traducciones = [];
      this.$refs.formEdit.reset();
    },
    async initPerfilesEdit() {
      var payload = {
        id: this.item.id,
        claveIdioma: "",
        usuario: 1
      };

      console.log(this.item.id);
      await this.$http
        .post(route("Roles/rolesVista"), payload)
        .then(
          async response => {
            console.log(response);
            if (response.body.code === 200) {
              this.traducciones = response.body.roles;
              for (let traduccion of this.traducciones) {
                this.payload.traducciones.push({
                  idRolTraduccion: traduccion.idRolTraduccion,
                  nombre: traduccion.nombre,
                  descripcion: traduccion.descripcion,
                  fechaModificacion: traduccion.fechaEdicion,
                  fechaCreacion: traduccion.fechaRegistro,
                  roles_idRol: traduccion.roles_idRol,
                  idioma_idIdioma: traduccion.idIdioma,
                  idioma: traduccion.idioma
                });
              }
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
      var _payload = {
        
        id: this.item.id,
        claveIdioma: "",
        usuario: 1
      };
      await this.$http
        .post(route("ModuloRol/getClaimsModule"), _payload)
        .then(
          async response => {
            if (response.body.code === 200) {
              this.datatemp = response.body.modulosRoles.filter(
                r => !r.externo
              );

              for (let modulo of this.datatemp) {
                
                let permisos = [];
                for(let permiso of modulo.claimsModule){
                  permisos.push(
                    {
                      id_ClaimsModule: permiso.id_ClaimsModule,
                      permiso: permiso.permiso,
                      status: permiso.status,
                      id_aspnetroleclaims: permiso.id_aspnetroleclaims
                    }
                  )
                }

                this.tableData.push ( 
                {
                  idmodule: modulo.idModuloRol,
                  idRol: 0,
                  titulo: modulo.nombreModulo,
                  permisos: permisos
                }
                );

                
              };


            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    async editRole() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      console.log(this.payload);

      //Inicia validacion de rol
      let items = [];
      for (let lang of this.payload.traducciones) {
        items.push({
          id: lang.roles_idRol, 
          name: lang.nombre
        });
      }
      const params = {
        edit: true,
        items: items
      }

      await this.$http
        .post(route("Roles/postExistRol"), params)
        .then(async (response) => {
          if (response.body.exist) {
              this.notifyMessage("danger", this.$t("app.modules.corporate_roles.promp.existing_role"));
            } else {
              this.payload.rolActualizar = {
                id: this.item.id,
                name: this.item.name,
                normalizedName: this.item.name,
                empresa: "string",
                idEmpresa: this.item.empresa_idEmpresa,
                active: this.item.active,
                externo: this.item.externo,
                activoStr: "string",
                concurrencyStamp: "2020-11-19T22:22:08.543Z",
                idRolUsuario: 0
              };
              await this.$http
                .patch(route("Roles/patchRolTraduccion"), this.payload)
                .then(
                  async response => {
                    console.log("Reponse de traducciones "+response.body.code)
                    console.log(response);
                    if (response.body.code === 200) {

                      var payload = {
                        claveIdioma: this.$store.state.lang,
                        usuario: this.$store.state.user.idUsuario,
                        
                        moduloPermisos: this.tableData
                        
                      };
                      await this.$http
                                .post(
                                  route("Roles/postPermisosByRol"),
                                  payload
                                )
                                .then(
                                  async response => {
                                    console.log(response);
                                    if (response.body.code === 200) {
                                      this.notifyMessage(
                                        "success",
                                        "Guardado con éxito"
                                      );
                                      this.$router.push({ name: 'Roles' })
                                    } else {
                                      this.notifyMessage(
                                        "danger",
                                        "Ha ocurrido un error"
                                      );
                                    }
                                  },
                                  error => {
                                    this.notifyMessage(
                                      "danger",
                                      "Ha ocurrido un error"
                                    );
                                  }
                                )
                                .finally(() => {});
                                payload = {};
                    } else {
                      this.notifyMessage("danger", this.$t("app.promps.error"));
                    }
                  },
                  error => {
                    this.notifyMessage("danger", this.$t("app.promps.error"));
                  }
                  
                )
                .finally(() => {});
            }
        })
      
      this.$swal.close();
    }
  }
};
</script>
<style>
.extended-forms .el-select {
  width: 100%;
  margin-bottom: 30px;
}
.card .alert {
  position: relative !important;
  width: 100%;
}

.modal-content .modal-header {
  padding-bottom: 24px;
  box-shadow: 0px 2px 5px 0px #00000021;
}

.modal-content .modal-body + .modal-footer {
  padding-top: 20px !important;
  background-color: #efefefb3;
}
</style>
